import type { NotificationQueryParams } from '@promotion/types'
import { useUserNotifications } from '#imports'

export const useNotificationDialogs = (options: {
    enabled?: NotificationQueryParams['enabled']
} = {}) => {
    const { enabled } = options

    return useUserNotifications({
        exclude_expired: true,
        exclude_read: true,
        key: 'notification:dialogs',
        lazy: true,
        enabled
    })
}
